// Mock data for Sparecraft Solutions

export const businessInfo = {
  name: "Sparecraft Solutions",
  tagline: "JCB & Forklift Spare Parts. Available When Your Machine Can't Wait.",
  phone: "7387313767",
  whatsapp: "7387313767",
  email: "sparecraft.ngp@gmail.com",
  address: "Chawala Complex, Wadi, Amravati road, Nagpur",
  gst: "27AAGDPPS0721G1ZA",
  businessHours: "Open 24 hours, Mon-Sat | Closed on Sunday",
  region: "Serving Maharashtra & Vidarbha"
};

export const jcbCategories = [
  {
    id: 1,
    name: "Engine Parts",
    description: "Pistons, rings, liners, gaskets, oil pumps",
    icon: "engine",
    parts: ["Piston Kit", "Cylinder Liner", "Engine Gasket Set", "Oil Pump", "Water Pump"]
  },
  {
    id: 2,
    name: "Hydraulic Parts",
    description: "Pumps, cylinders, valves, hoses, seals",
    icon: "droplet",
    parts: ["Hydraulic Pump", "Lift Cylinder", "Control Valve", "Hydraulic Hose", "Seal Kit"]
  },
  {
    id: 3,
    name: "Electrical & Sensors",
    description: "Alternators, starters, sensors, switches",
    icon: "zap",
    parts: ["Alternator", "Starter Motor", "Oil Pressure Sensor", "Temperature Sensor", "Ignition Switch"]
  },
  {
    id: 4,
    name: "Transmission & Axle",
    description: "Clutch plates, gears, axle shafts, bearings",
    icon: "cog",
    parts: ["Clutch Plate", "Transmission Gear", "Axle Shaft", "Differential", "Bearing Kit"]
  },
  {
    id: 5,
    name: "Wear Parts",
    description: "Bucket teeth, bushes, pins, cutting edges",
    icon: "wrench",
    parts: ["Bucket Teeth", "Bush Kit", "Pin Set", "Cutting Edge", "Wear Plates"]
  },
  {
    id: 6,
    name: "Filters & Service Kits",
    description: "Oil, fuel, air, hydraulic filters",
    icon: "filter",
    parts: ["Oil Filter", "Fuel Filter", "Air Filter", "Hydraulic Filter", "Service Kit"]
  }
];

export const forkliftCategories = [
  {
    id: 7,
    name: "Engine & Powertrain",
    description: "For diesel, electric, and LPG forklifts",
    icon: "cpu",
    parts: ["Engine Assembly", "Carburetor", "Fuel Pump", "Ignition Coil", "Spark Plug"]
  },
  {
    id: 8,
    name: "Hydraulic Components",
    description: "Lift cylinders, pumps, control valves",
    icon: "droplet",
    parts: ["Lift Cylinder", "Tilt Cylinder", "Hydraulic Pump", "Control Valve", "Pressure Gauge"]
  },
  {
    id: 9,
    name: "Brake System",
    description: "Brake pads, shoes, master cylinder, lines",
    icon: "disc",
    parts: ["Brake Pad", "Brake Shoe", "Master Cylinder", "Brake Line", "Brake Fluid Reservoir"]
  },
  {
    id: 10,
    name: "Steering & Suspension",
    description: "Steering components, shock absorbers",
    icon: "compass",
    parts: ["Steering Column", "Steering Cylinder", "Shock Absorber", "King Pin", "Steering Wheel"]
  },
  {
    id: 11,
    name: "Electrical & Controllers",
    description: "Motors, controllers, batteries, cables",
    icon: "battery",
    parts: ["Traction Motor", "Controller", "Battery", "Cable Assembly", "Relay"]
  },
  {
    id: 12,
    name: "Mast, Chains & Rollers",
    description: "Mast sections, lift chains, rollers",
    icon: "link",
    parts: ["Mast Channel", "Lift Chain", "Chain Roller", "Anchor Pin", "Side Roller"]
  },
  {
    id: 13,
    name: "Tyres & Wear Parts",
    description: "Solid tyres, pneumatic tyres, fork tips",
    icon: "circle",
    parts: ["Solid Tyre", "Pneumatic Tyre", "Fork", "Fork Tip", "Load Backrest"]
  }
];

export const valuePoints = [
  {
    title: "Ready Stock",
    description: "We maintain inventory of fast-moving parts. No long waits.",
    icon: "package"
  },
  {
    title: "Correct Identification",
    description: "We help you identify the exact part for your machine model.",
    icon: "search"
  },
  {
    title: "Genuine & OEM Options",
    description: "Authentic parts and trusted OEM-equivalent alternatives.",
    icon: "shield-check"
  },
  {
    title: "Retail + Wholesale",
    description: "Single part orders and bulk supply for workshops & dealers.",
    icon: "users"
  }
];

export const trustIndicators = [
  { label: "GST Registered", value: businessInfo.gst },
  { label: "Business Hours", value: businessInfo.businessHours },
  { label: "Serving", value: businessInfo.region },
  { label: "Response Time", value: "Quick WhatsApp Support" }
];

export const supportedModels = {
  jcb: ["JCB 3DX", "JCB 3CX", "JCB 4DX", "JCB 2DX"],
  forklift: ["Diesel Forklift", "Electric Forklift", "LPG Forklift", "All Major Brands"]
};

export const mockEnquiries = [];

export const addEnquiry = (enquiry) => {
  mockEnquiries.push({
    id: Date.now(),
    ...enquiry,
    timestamp: new Date().toISOString()
  });
  console.log("Enquiry submitted:", enquiry);
  return true;
};
